import { useAuth } from "@/context/AuthContext";
import OrlaPublic from "@/pages/public/OrlaPublic";
import OrlaChat from "@/pages/member/OrlaChat";

// /orla shows the public intro to visitors, and the live assistant to
// verified investors and admins.
export default function OrlaGate() {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return null;
  if (user && (isAdmin || user.status === "verified")) return <OrlaChat />;
  return <OrlaPublic />;
}
